import { render, staticRenderFns } from "./LGT.vue?vue&type=template&id=25500359&scoped=true&"
import script from "./LGT.vue?vue&type=script&lang=js&"
export * from "./LGT.vue?vue&type=script&lang=js&"
import style0 from "./LGT.vue?vue&type=style&index=0&id=25500359&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25500359",
  null
  
)

export default component.exports